import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
export const ITreeSitterParserService = createDecorator('treeSitterParserService');
